var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDetailVisionBgS(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 202,
    viewBox: "0 0 350 203",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.9231,
    cy: 27.4622,
    r: 26.5231,
    stroke: "#0A1214",
    strokeWidth: 0.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 323.077,
    cy: 27.4622,
    r: 26.5231,
    stroke: "#0A1214",
    strokeWidth: 0.8
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.9231,
    cy: 101.501,
    r: 26.5231,
    stroke: "#0A1214",
    strokeWidth: 0.8
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 323.077,
    cy: 101.501,
    r: 26.5231,
    stroke: "#0A1214",
    strokeWidth: 0.8
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.9231,
    cy: 175.54,
    r: 26.5231,
    stroke: "#0A1214",
    strokeWidth: 0.8
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 323.077,
    cy: 175.54,
    r: 26.5231,
    stroke: "#0A1214",
    strokeWidth: 0.8
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 175,
    cy: 101.501,
    r: 78.077,
    stroke: "#0A1214",
    strokeOpacity: 0.2,
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeDasharray: "0.1 3"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 175,
    cy: 27.4622,
    r: 26.5231,
    fill: "",
    stroke: "#0A1214",
    strokeWidth: 0.8
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 175,
    cy: 101.501,
    r: 26.5231,
    fill: "url(#paint0_radial_187_6827)",
    stroke: "#0A1214",
    strokeWidth: 0.8
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 175,
    cy: 175.54,
    r: 26.5231,
    fill: "",
    stroke: "#0A1214",
    strokeWidth: 0.8
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 100.962,
    cy: 27.4622,
    r: 26.5231,
    stroke: "#0A1214",
    strokeWidth: 0.8
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 249.038,
    cy: 27.4622,
    r: 26.5231,
    stroke: "#0A1214",
    strokeWidth: 0.8
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 100.962,
    cy: 175.54,
    r: 26.5231,
    stroke: "#0A1214",
    strokeWidth: 0.8
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 249.038,
    cy: 175.54,
    r: 26.5231,
    stroke: "#0A1214",
    strokeWidth: 0.8
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 249.038,
    cy: 101.501,
    r: 26.5231,
    fill: "",
    stroke: "#0A1214",
    strokeWidth: 0.8
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 100.962,
    cy: 101.501,
    r: 26.5231,
    fill: "",
    stroke: "#0A1214",
    strokeWidth: 0.8
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailVisionBgS);
export default __webpack_public_path__ + "static/media/detailVisionBgS.97050ebe5df7235e61f722ea65cac57f.svg";
export { ForwardRef as ReactComponent };